module.exports = __webpack_public_path__ + "media/images/link_black-833a1782.svg";